// // import React, { useState, useRef, useEffect } from "react";
// // import { Link ,useLocation } from "react-router-dom";
// // import Tablereservation from "./Tablereservation";
// // import Tablereservationcode from "./Tablereservationcode";
// // import Waiterpage from "./Waiterpage";
// // import './Tablemanagement.css';
// // const PrimiumTable = () => {
// //      const location = useLocation();

// //     const [activeTab, setActiveTab] = useState(
// //         location.state?.activeTab || "Vendor Bookings"
// //     );

// //     // Update activeTab if navigation state changes (optional)
// //     useEffect(() => {
// //         if (location.state?.activeTab) {
// //             setActiveTab(location.state.activeTab);
// //         }
// //     }, [location.state])
// //     const [formData1, setFormData1] = useState({
// //         "offer type": "",
// //         "Discount Percentage": "",
// //         "Start Date": "",
// //         "End Date": "",
// //         Description: "",
// //         goal: "",
// //         status: "Active", // Added status 
// //     });
// //     const tabContent = {
// //         "Vendor Bookings": <Tablereservation />,
// //         "Waiters Bookings": <Waiterpage />,
// //         "User Bookings": <Tablereservationcode />,

// //     };

// //     return (
// //         <div className="container-fluid">
// //             <div className="row">

// //                 <div className="col-lg-12" >

// //                     <div className="discount-container" style={{display:"flex", flexDirection:"column"}}>
// //                         {/* Responsive, centered tab buttons */}
// //                         <div
// //                             style={{
// //                                 display: "flex",
// //                                 justifyContent: "center",
// //                                 alignItems: "center",
// //                                 position: "fixed",
// //                                 top: "158px",
// //                                 left: "51%",
// //                                 transform: "translate(-45%, -50%)",
// //                                 gap: "0px",
// //                                 zIndex: 10,
// //                                 width: "90vw",
// //                                 maxWidth: "600px",
// //                                 flexWrap: "wrap",
// //                                 padding: "10px 0",
// //                             }}
// //                             className="rorr row b2"
// //                         >
// //                             {Object.keys(tabContent).map((label) => (
// //                                 <div
// //                                     key={label}
// //                                     className="col-lg-3 col-md-6 col-sm-12 col-12"
// //                                     style={{
// //                                         display: "flex",
// //                                         justifyContent: "center",
// //                                         marginBottom: "10px",
// //                                         minWidth: "150px",
// //                                     }}
// //                                 >
// //                                     <button
// //                                         onClick={() => setActiveTab(label)}
// //                                         style={{
// //                                             border: "none",
// //                                             borderRadius: "10px",
// //                                             minWidth: "140px",
// //                                             width: "100%",
// //                                             padding: "0 10px",
// //                                             height: "40px",
// //                                             backgroundColor: activeTab === label ? "#b15cd6" : "#d9d9d9",
// //                                             color: activeTab === label ? "#fff" : "#000",
// //                                             fontWeight: "bold",
// //                                             cursor: "pointer",
// //                                             transition: "background-color 0.3s ease",
// //                                             fontSize: "1rem",
// //                                         }}
// //                                     >
// //                                         {label}
// //                                     </button>
// //                                 </div>
// //                             ))}
// //                         </div>
// //                         {/* Tab Content - Scrollable Part */}
// //                         <div
// //                             style={{
// //                                 height: "72vh",
// //                                 overflowY: "auto",
// //                                 scrollbarWidth: "thin",
// //                                 paddingTop: "0px",
// //                                 marginTop:"10px",
// //                                 borderRadius: "8px",

// //                             }}
// //                             className="b1"
// //                         >
// //                             {tabContent[activeTab]}
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // };

// // export default PrimiumTable;





// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import Tablereservation from "./Tablereservation";
// import Tablereservationcode from "./Tablereservationcode";
// import Waiterpage from "./Waiterpage";
// import './Tablemanagement.css';

// const PrimiumTable = () => {
//     const location = useLocation();
//     const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//     const [activeTab, setActiveTab] = useState(
//         location.state?.activeTab || "Vendor Bookings"
//     );
//     const [clickDebug, setClickDebug] = useState("");

//     // Handle window resize
//     useEffect(() => {
//         const handleResize = () => setWindowWidth(window.innerWidth);
//         window.addEventListener('resize', handleResize);
//         return () => window.removeEventListener('resize', handleResize);
//     }, []);

//     const tabContent = {
//         "Vendor Bookings": <Tablereservation />,
//         "Waiters Bookings": <Waiterpage />,
//         "User Bookings": <Tablereservationcode />,
//     };

//     // Add this in your component or in a script tag
//     useEffect(() => {
//         const checkClickBlockers = () => {
//             const elementsAtCenter = document.elementsFromPoint(
//                 window.innerWidth / 2,
//                 150 // Y position of your tabs
//             );
//             console.log("Elements at tab position:", elementsAtCenter);
//         };

//         // Check after mount
//         setTimeout(checkClickBlockers, 1000);
//     }, []);

//     const isMobile = windowWidth <= 768;

//     // Debug click handler
//     const handleTabClick = (label) => {
//         setClickDebug(`Clicked: ${label} at ${new Date().toLocaleTimeString()}`);
//         console.log(`Tab clicked: ${label}`);
//         setActiveTab(label);
//     };

//     return (
//         <div className="container-fluid px-0" onClick={(e) => {
//             console.log("Container clicked at:", e.target);
//         }}>

//             <style>{`
//             .heightfix{
//             height: 80vh !important;
//     overflow: auto;
//             }



//             `}</style>
//             <div className="row mx-0">
//                 <div className="col-12 px-2 px-md-3 heightfix" style={{ width: window.innerWidth < 500 ? "90vw" : " ", }}>

//                     {/* TAB NAVIGATION - Absolute minimal styling */}
//                     <div style={{
//                         marginTop: isMobile ? "0px" : "60px",
//                         marginBottom: "0px",
//                         position: "relative",
//                         backgroundColor: "transparent"
//                     }}>
//                         <div style={{
//                             display: "flex",
//                             justifyContent: "center",
//                             alignItems: "center",
//                             flexWrap: "wrap",
//                             gap: "10px",
//                             padding: "10px",
//                             backgroundColor: "white",
//                             borderRadius: "10px",
//                         }}>
//                             {Object.keys(tabContent).map((label) => (
//                                 <div key={label} style={{
//                                     position: "relative",
//                                     zIndex: 100
//                                 }}>
//                                     <button
//                                         onClick={() => handleTabClick(label)}
//                                         onTouchStart={() => console.log("Touch start on:", label)}
//                                         onTouchEnd={() => console.log("Touch end on:", label)}
//                                         style={{
//                                             padding: "12px 20px",
//                                             backgroundColor: activeTab === label ? "#b15cd6" : "#e0e0e0",
//                                             color: activeTab === label ? "white" : "#333",
//                                             border: "none",
//                                             borderRadius: "8px",
//                                             fontSize: isMobile ? "14px" : "16px",
//                                             fontWeight: "bold",
//                                             cursor: "pointer",
//                                             minWidth: "120px",
//                                             minHeight: "44px", // Minimum for touch targets
//                                             touchAction: "manipulation",
//                                             WebkitTapHighlightColor: "transparent",
//                                             userSelect: "none"
//                                         }}
//                                     >
//                                         {label}
//                                     </button>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>

//                     {/* TAB CONTENT */}
//                     <div style={{
//                         minHeight: "300px",
//                         backgroundColor: "white",
//                         borderRadius: "10px",
//                         padding: "10px 15px 0px 0px",
//                         width: window.innerWidth < 500 ? "94vw" : " ",
//                     }}>
//                         {tabContent[activeTab]}
//                     </div>

//                 </div>
//             </div>
//         </div>
//     );
// };

// export default PrimiumTable;

import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Tablereservation from "./Tablereservation";
import Tablereservationcode from "./Tablereservationcode";
import Waiterpage from "./Waiterpage";
import './Tablemanagement.css';

const PrimiumTable = () => {
    const location = useLocation();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [activeTab, setActiveTab] = useState(
        location.state?.activeTab || "Vendor Bookings"
    );
    const contentRef = useRef(null);

    // Handle window resize
    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const tabContent = {
        "Vendor Bookings": <Tablereservation />,
        "Waiters Bookings": <Waiterpage />,
        "User Bookings": <Tablereservationcode />,
    };

    const isMobile = windowWidth <= 768;
    const isSmallMobile = windowWidth <= 500;

    // Calculate top position based on breadcrumb height
    const getTabTopPosition = () => {
        // These values should match the breadcrumb top positions in Foodtablemanagment
        if (windowWidth <= 430) return "100px"; // 50px breadcrumb + 50px margin
        if (windowWidth <= 768) return "105px"; // 55px breadcrumb + 50px margin
        return "114px"; // 64px breadcrumb + 50px margin
    };

    return (
        <div className="container-fluid px-0">
            <style>{`
                .tab-content-wrapper {
                    height: ${isMobile ? "calc(100vh - 180px)" : "calc(100vh - 200px)"} !important;
                    overflow-y: auto !important;
                    margin-top: ${isMobile ? "20px" : "60px"} !important;
                }
                
                @media (max-width: 768px) {
                    .tab-content-wrapper {
                        width: 105% !important;
                        margin-left: 0 !important;
                        margin-right: 0 !important;
                    }
                }
                    @media screen and (max-width: 768px) {
                        .row {
                            margin-top: 50px !important;
                        }
                    }


            `}</style>

            <div className="row mx-0">
                <div className="col-12 px-2 px-md-3" style={{ width: window.innerWidth < 500 ? "95vw" : " ", }}>

                    {/* FIXED TAB NAVIGATION - Doesn't scroll */}
                    <div
                        className="fixed-tab-navigation"
                        style={{
                            position: "fixed",
                            top: getTabTopPosition(),
                            left: "50%",
                            transform: "translateX(-50%)",
                            width: isSmallMobile ? "95%" : isMobile ? "90%" :   window.innerWidth<1500 ?"50%" : " 30%",
                            maxWidth: "800px",
                            zIndex: 900,
                            padding: isMobile ? "10px 5px" : "15px 10px",
                            backgroundColor: "#fff",
                            borderRadius: "12px",
                        }}
                    >
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: isMobile ? "5px" : "10px",
                            width: "100%"
                        }}>
                            {Object.keys(tabContent).map((label) => (
                                <button
                                    key={label}
                                    onClick={() => setActiveTab(label)}
                                    style={{
                                        flex: "1",
                                        padding: isMobile ? "10px 5px" : "12px 8px",
                                        backgroundColor: activeTab === label ? "#b15cd6" : "#f0f0f0",
                                        color: activeTab === label ? "#fff" : "#333",
                                        border: "none",
                                        borderRadius: "8px",
                                        fontSize: isSmallMobile ? "12px" : isMobile ? "13px" : "14px",
                                        fontWeight: "600",
                                        cursor: "pointer",
                                        transition: "all 0.3s ease",
                                        minHeight: "44px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        touchAction: "manipulation"
                                    }}
                                >
                                    {label}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* TAB CONTENT - Scrollable area */}
                    <div
                        ref={contentRef}
                        className="tab-content-wrapper"
                        style={{
                            backgroundColor: "#fff",
                            padding: isMobile ? "0px" : "0px",
                            width: isSmallMobile ? "95%" : isMobile ? "90%" : "100%",
                            // maxWidth: "800px",
                            scrollbarWidth:window.innerWidth<500 ? "none" : "none",

                        }}
                    >
                        {tabContent[activeTab]}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PrimiumTable;